import { memo } from "react"

const WarrantyHistory = () => {
  return (
    <>
      Lịch sử bảo hành
    </>
  )
}

export default memo(WarrantyHistory)